import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService } from '@examdojo/supabase';
import {
  getNameAndBucketNameFromLocalQuestionImageUrl,
  getNameAndBucketNameFromRemoteQuestionImageUrl,
  LocalQuestionImageUrl,
  RemoteQuestionImageUrl,
} from '@examdojo/models/question-image';

@Injectable({
  providedIn: 'root',
})
export class QuestionImageUploadService {
  constructor(private readonly supabase: ExamdojoSupabaseService) {}

  async uploadImage(image: File, imageUrl: LocalQuestionImageUrl): Promise<RemoteQuestionImageUrl> {
    const { bucketName, imageName } = getNameAndBucketNameFromLocalQuestionImageUrl(imageUrl);

    await this.supabase.uploadFile(bucketName, image, image.type, imageName);

    return `s3://${bucketName}/${imageName}`;
  }

  removeImage(imageUrl: RemoteQuestionImageUrl) {
    const { bucketName, imageName } = getNameAndBucketNameFromRemoteQuestionImageUrl(imageUrl);
    return this.supabase.removeFiles(bucketName, imageName);
  }

  fetchSignedUrlFromImageUrl(imageUrl: RemoteQuestionImageUrl): Promise<string> {
    const { bucketName, imageName } = getNameAndBucketNameFromRemoteQuestionImageUrl(imageUrl);

    if (!bucketName) {
      throw new Error('Bucket name does not exist in the image url');
    }

    return this.supabase.getSignedUrlForFile(bucketName, imageName);
  }
}
